/**
 * Do not edit directly
 * Generated on Mon, 26 Jun 2023 05:02:05 GMT
 */

module.exports = {
  'caption-text': {
    fontSize: '10px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '0.3px',
    lineHeight: '13px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'body-text-large': {
    fontSize: '18px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '-0.36px',
    lineHeight: '26px',
    paragraphIndent: 0,
    paragraphSpacing: 26,
    textCase: 'none',
  },
  'body-text-bold': {
    fontSize: '14.5px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '0px',
    lineHeight: '20px',
    paragraphIndent: 0,
    paragraphSpacing: 6,
    textCase: 'none',
  },
  'body-text': {
    fontSize: '14.5px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '0.14px',
    lineHeight: '18.2px',
    paragraphIndent: 0,
    paragraphSpacing: 6,
    textCase: 'none',
  },
  'button-and-tag-text': {
    fontSize: '11px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '0.55px',
    lineHeight: '20px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'body-text-large-bold': {
    fontSize: '18px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '-0.36px',
    lineHeight: '26px',
    paragraphIndent: 0,
    paragraphSpacing: 26,
    textCase: 'none',
  },
  'm-h1': {
    fontSize: '68px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 300,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '-2.04px',
    lineHeight: '64.6px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'm-h2': {
    fontSize: '58px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 300,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '-1.74px',
    lineHeight: '55.68px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'm-h3': {
    fontSize: '44px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 300,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '-0.88px',
    lineHeight: '42.24px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'm-h3-navigation': {
    fontSize: '44px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 300,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '-0.88px',
    lineHeight: '48.4px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'm-h4': {
    fontSize: '36px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 300,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '-1.08px',
    lineHeight: '34.56px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'm-h5': {
    fontSize: '30px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 300,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '-0.9px',
    lineHeight: '28.8px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'm-h6': {
    fontSize: '24px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 300,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '-0.72px',
    lineHeight: '26.4px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'd-h1': {
    fontSize: '100px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 300,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '1px',
    lineHeight: '90px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'd-h2': {
    fontSize: '78px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 300,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '-2.34px',
    lineHeight: '74.88px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'd-h3': {
    fontSize: '64px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 300,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '-1.28px',
    lineHeight: '61.44px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'd-h4': {
    fontSize: '48px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 300,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '-0.96px',
    lineHeight: '46.08px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'd-h5': {
    fontSize: '34px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 300,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '-1.02px',
    lineHeight: '40.8px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'd-h6': {
    fontSize: '24px',
    textDecoration: 'none',
    fontFamily: 'NB International Pro',
    fontWeight: 300,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '-0.72px',
    lineHeight: '26.4px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
};
